export class DocumentDetails {

    private type: string;
    private typeKey: string;
    private name: string;
    private url: string;
    private isVerified: string;
    private id: number;
    private isAdded: boolean;
    private file: any;
    private extension: string;
    private canDelete: boolean;
    private isCopy : boolean;

    constructor(documentDetailsDto: any) {
        this.canDelete = documentDetailsDto.canDelete;
        this.type = documentDetailsDto.type;
        this.typeKey = documentDetailsDto.typeKey;
        this.isCopy= (documentDetailsDto.isCopy)?documentDetailsDto.isCopy:false;
        this.name = documentDetailsDto.name;
        this.url = documentDetailsDto.url;
        this.isVerified = documentDetailsDto.isVerified;
        this.id = documentDetailsDto.id;
        this.isAdded = documentDetailsDto.isAdded;
        this.file = documentDetailsDto.file;
        this.extension = documentDetailsDto.extension;
    }

/**
     * Getter $isCopy
     * @return {boolean}
     */
    public get $isCopy(): boolean {
        return this.isCopy;
    }

    /**
     * Setter $isCopy
     * @param {boolean} value
     */
    public set $isCopy(value: boolean) {
        this.isCopy = value;
    }


    /**
     * Getter $canDelete
     * @return {boolean}
     */
    public get $canDelete(): boolean {
        return this.canDelete;
    }

    /**
     * Setter $canDelete
     * @param {boolean} value
     */
    public set $canDelete(value: boolean) {
        this.canDelete = value;
    }



    /**
     * Getter $extension
     * @return {string}
     */
    public get $extension(): string {
        return this.extension;
    }

    /**
     * Setter $extension
     * @param {string} value
     */
    public set $extension(value: string) {
        this.extension = value;
    }

    /**
     * Getter $file
     * @return {any}
     */
    public get $file(): any {
        return this.file;
    }

    /**
     * Setter $file
     * @param {any} value
     */
    public set $file(value: any) {
        this.file = value;
    }

    /**
     * Getter $id
     * @return {number}
     */
    public get $id(): number {
        return this.id;
    }

    /**
     * Getter $isAdded
     * @return {boolean}
     */
    public get $isAdded(): boolean {
        return this.isAdded;
    }

    /**
     * Setter $id
     * @param {number} value
     */
    public set $id(value: number) {
        this.id = value;
    }

    /**
     * Setter $isAdded
     * @param {boolean} value
     */
    public set $isAdded(value: boolean) {
        this.isAdded = value;
    }

    /**
     * Getter $type
     * @return {string}
     */
    public get $type(): string {
        return this.type;
    }

    /**
     * Getter $typeKey
     * @return {string}
     */
    public get $typeKey(): string {
        return this.typeKey;
    }

    /**
     * Getter $name
     * @return {string}
     */
    public get $name(): string {
        return this.name;
    }

    /**
     * Getter $url
     * @return {string}
     */
    public get $url(): string {
        return this.url;
    }

    /**
     * Getter $isVerified
     * @return {string}
     */
    public get $isVerified(): string {
        return this.isVerified;
    }

    /**
     * Setter $type
     * @param {string} value
     */
    public set $type(value: string) {
        this.type = value;
    }

    /**
     * Setter $typeKey
     * @param {string} value
     */
    public set $typeKey(value: string) {
        this.typeKey = value;
    }

    /**
     * Setter $name
     * @param {string} value
     */
    public set $name(value: string) {
        this.name = value;
    }

    /**
     * Setter $url
     * @param {string} value
     */
    public set $url(value: string) {
        this.url = value;
    }

    /**
     * Setter $isVerified
     * @param {string} value
     */
    public set $isVerified(value: string) {
        this.isVerified = value;
    }
}
